<template>
    <div class="item-box flex ">
       <div :class="currentTabs===1 ? 'active':''" @click="handleTabChange(1,1)"
         class="flexBetween itemsCenter" >
         24H更新
        </div>
        <div 
           :class="currentTabs===item.positionTypeId ? 'active':''"
           v-for="item in datas" 
           @click="handleTabChange(item.positionTypeId,2)"
           :key="item.positionTypeId" class="flexBetween itemsCenter" >
           {{ item.positionTypeName }}  
        </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
        datas:{
            type:Array,
            default:()=>{}
        }
    },
    data() {
      return {
        currentTabs:1,
      };
    },

    methods: {
        handleTabChange(id,type){
            this.currentTabs = id;
            let datas={
              id,
              type
            }
            this.$emit('updateTabs',datas)
        },
       
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
    $mianColor:#287CF3;
    .item-box {
        border-bottom: 1px solid #D8D8D8;
        margin-bottom: 20px;
        div{
            padding: 0 20px 14px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: $secondfontCol;
            border-bottom: 2px solid rgba(249, 251, 255, 0);
            cursor: pointer;
            transition: all .2s linear;
        }
        .active{
            border-bottom: 2px solid $mianColor;
            color: $mianColor;
            font-weight: 500;
        }
       
    }
  </style>
  